import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const links = [
  { to: "/platform", label: "Platform" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/security", label: "Security" },
  { to: "/industries", label: "Industries" },
  { to: "/insights", label: "Insights" },
  { to: "/about", label: "About" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    document.body.style.overflow = "";
  }, [pathname]);

  const navClass = `nav${scrolled ? " scrolled" : ""}${open ? " open" : ""}`;

  return (
    <>
      <header className={navClass} id="nav" data-testid="site-header">
        <div className="nav__inner">
          <Link to="/" className="brand" aria-label="Docket home" data-testid="brand-link">
            <svg className="brand__mark" viewBox="0 0 28 28" fill="none" aria-hidden="true">
              <rect x="6.5" y="3.5" width="15" height="19" rx="2.2" fill="#F5F8F9" stroke="#103049" strokeWidth="1.6" />
              <rect x="3.5" y="6.5" width="15" height="19" rx="2.2" fill="#103049" />
              <path d="M7.4 12.2h7.2M7.4 15.6h7.2M7.4 19h4.4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <span className="brand__name">Docket</span>
            <span className="brand__by">by Devnco</span>
          </Link>
          <nav className="nav__links" aria-label="Primary">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="nav__cta">
            <Link to="/contact" className="btn btn--primary" data-testid="nav-cta-pilot">Request a pilot</Link>
            <button
              className="nav__burger"
              id="burger"
              aria-label="Open menu"
              aria-expanded={open}
              data-testid="mobile-menu-toggle"
              onClick={() => {
                const next = !open;
                setOpen(next);
                document.body.style.overflow = next ? "hidden" : "";
              }}
            >
              <span />
            </button>
          </div>
        </div>
      </header>
      <div className={`mobile-menu${open ? " show" : ""}`} id="mobileMenu">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} data-testid={`mobile-nav-${l.to.slice(1)}`}>
            {l.label}
          </NavLink>
        ))}
        <Link to="/contact" className="btn btn--primary" data-testid="mobile-nav-cta">Request a pilot</Link>
      </div>
    </>
  );
}
